import { useState } from 'react'
import { FacilitiesBase } from './FacilitiesBase'
import { FacilitiesMarina } from './FacilitiesMarina'
import { FacilitiesSkills } from './FacilitiesSkills'
import { FacilitiesFusion } from './FacilitiesFusion'
import { FacilitiesTitles } from './FacilitiesTitles'
import { FacilitiesJuiceBar } from './FacilitiesJuiceBar'
import { FacilitiesAwakening } from './FacilitiesAwakening'
import { FacilitiesDungeon } from './FacilitiesDungeon'
import { FacilitiesSalvage } from './FacilitiesSalvage'
import { FacilitiesGadgets } from './FacilitiesGadgets'

export const Facilities = () => {
    const [activeFacilities, setActiveFacilities] = useState('facilities')
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    const FacilitiesNav = () => {
        return (
            <nav className='mx-auto my-8'>
                <ul className='&>li>img]:mx-auto [&>li>img]:w-full  [&>li]:w-[47%] [&>li]:md:w-[25%] cursor-pointer flex justify-center gap-4 flex-wrap mx-auto px-4 md:px-0 max-w-[1200px] items-end'>
                    <li>
                        <img
                            onClick={() => {
                                setActiveFacilities('facilities')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'facilities' && 'brightness-125'
                            }  mx-auto hover:brightness-125 duration-300`}
                            alt='system basics'
                            src={`${process.env.PUBLIC_URL}/images/system/header-facilities-system.webp`}
                        />
                    </li>
                    <li>
                        <img
                            onClick={() => {
                                setActiveFacilities('marina')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'marina' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confire'
                            src={`${process.env.PUBLIC_URL}/images/system/header-marina-system.webp`}
                        />
                    </li>
                    <li className='relative inline-block '>
                        <img
                            onClick={() => {
                                setActiveFacilities('skills')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'skills' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='confriend'
                            src={`${process.env.PUBLIC_URL}/images/system/header-skills-system.webp`}
                        />{' '}
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('fusion')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'fusion' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='fusion'
                            src={`${process.env.PUBLIC_URL}/images/system/header-fusion-system.webp`}
                        />
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('titles')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'titles' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='titles'
                            src={`${process.env.PUBLIC_URL}/images/system/header-titles-system.webp`}
                        />
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('juicebar')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'juicebar' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='juicebar'
                            src={`${process.env.PUBLIC_URL}/images/system/header-juicebar-system.webp`}
                        />
                    </li>
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('awakening')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'awakening' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='awakening'
                            src={`${process.env.PUBLIC_URL}/images/system/header-awakening-system.webp`}
                        />
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('dungeon')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'dungeon' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='dungeon'
                            src={`${process.env.PUBLIC_URL}/images/system/header-dungeon-system.webp`}
                        />
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('salvage')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'salvage' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='salvage'
                            src={`${process.env.PUBLIC_URL}/images/system/header-salvage-system.webp`}
                        />
                    </li>{' '}
                    <li>
                        {' '}
                        <img
                            onClick={() => {
                                setActiveFacilities('gadgets')
                                scrollToTop()
                            }}
                            className={` ${
                                activeFacilities === 'gadgets' && 'brightness-125'
                            }  hover:brightness-125 duration-300`}
                            alt='gadgets'
                            src={`${process.env.PUBLIC_URL}/images/system/header-gadgets-system.webp`}
                        />
                    </li>
                </ul>
            </nav>
        )
    }
    return (
        <>
            <FacilitiesNav />
            <div className='max-w-[1200px] mx-auto my-12 md:my-20'>
                {(() => {
                    switch (activeFacilities) {
                        case 'facilities':
                            return <FacilitiesBase />
                        case 'marina':
                            return <FacilitiesMarina />
                        case 'skills':
                            return <FacilitiesSkills />
                        case 'fusion':
                            return <FacilitiesFusion />
                        case 'titles':
                            return <FacilitiesTitles />
                        case 'juicebar':
                            return <FacilitiesJuiceBar />
                        case 'awakening':
                            return <FacilitiesAwakening />
                        case 'dungeon':
                            return <FacilitiesDungeon />
                        case 'salvage':
                            return <FacilitiesSalvage />
                        case 'gadgets':
                            return <FacilitiesGadgets />

                        default:
                            return null
                    }
                })()}
            </div>{' '}
            <FacilitiesNav />
        </>
    )
}
